export default {
	namespaced: true,
	state: {
		userToken: null,
		userTokenNew: null,
		orderToken: null,
		refundApplyDetail: null,
		userInfo: null,
		buyNuminfo: null,
		cruiseinfo: null
	},
	getters: {
		userTokenNew: state => {
			if (!state.userTokenNew) {
				try {
					const userTokenNew = localStorage.getItem('userTokenNew')
					// state.userToken = JSON.parse(userToken)
					state.userTokenNew = userTokenNew
				} catch (e) {
					console.error(e)
				}
			}
			return state.userTokenNew
		},
		userToken: state => {
			if (!state.userToken) {
				try {
					const userToken = localStorage.getItem('userToken')
					// state.userToken = JSON.parse(userToken)
					state.userToken = userToken
				} catch (e) {
					console.error(e)
				}
			}
			return state.userToken
		},
		orderToken: state => {
			if (!state.orderToken) {
				try {
					const orderToken = localStorage.getItem('orderToken')
					// state.userToken = JSON.parse(userToken)
					state.orderToken = orderToken
				} catch (e) {
					console.error(e)
				}
			}
			return state.orderToken
		},
		refundApplyDetail: state => {
			if (!state.refundApplyDetail) {
				try {
					const refundApplyDetail = localStorage.getItem('refundApplyDetail')
					state.refundApplyDetail = JSON.parse(refundApplyDetail)
					state.refundApplyDetail = state.refundApplyDetail ? state.refundApplyDetail : {}
				} catch (e) {
					console.error(e)
				}
			}
			return state.refundApplyDetail
		},
		userInfo: state => {
			if (!state.userInfo) {
				try {
					const userInfo = localStorage.getItem('userInfo')
					state.userInfo = JSON.parse(userInfo)
					state.userInfo = state.userInfo ? state.userInfo : {}
				} catch (e) {
					console.error(e)
				}
			}
			return state.userInfo
		},
		buyNuminfo: state => {
			if (!state.buyNuminfo) {
				try {
					const buyNuminfo = localStorage.getItem('buyNuminfo')
					state.buyNuminfo = JSON.parse(buyNuminfo)
					state.buyNuminfo = state.buyNuminfo ? state.buyNuminfo : {}
				} catch (e) {
					console.error(e)
				}
			}
			return state.buyNuminfo
		},
		contactinfo: state => {
			if (!state.contactinfo) {
				try {
					const contactinfo = localStorage.getItem('contactinfo')
					state.contactinfo = JSON.parse(contactinfo)
					state.contactinfo = state.contactinfo ? state.contactinfo : {}
				} catch (e) {
					console.error(e)
				}
			}
			return state.contactinfo
		},
		cruiseinfo: state => {
			if (!state.cruiseinfo) {
				try {
					const cruiseinfo = localStorage.getItem('cruiseinfo')
					state.cruiseinfo = JSON.parse(cruiseinfo)
					state.cruiseinfo = state.cruiseinfo ? state.cruiseinfo : {}
				} catch (e) {
					console.error(e)
				}
			}
			return state.cruiseinfo
		},
	},
	mutations: {
		setUserTokenNew(state, userTokenNew) {
			state.userTokenNew = userTokenNew
			localStorage.setItem('userTokenNew', userTokenNew)
		},
		setUserToken(state, userToken) {
			state.userToken = userToken
			localStorage.setItem('userToken', userToken)
		},
		setOrderToken(state, orderToken) {
			state.orderToken = orderToken
			localStorage.setItem('orderToken', orderToken)
		},
		setRefundApplyDetail(state, refundApplyDetail) {
			state.refundApplyDetail = refundApplyDetail
			localStorage.setItem('refundApplyDetail', JSON.stringify(refundApplyDetail))
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo
			localStorage.setItem('userInfo', JSON.stringify(userInfo))
		},
		setBuyNum(state, buyNuminfo) {
			state.buyNuminfo = buyNuminfo
			localStorage.setItem('buyNuminfo', JSON.stringify(buyNuminfo))
		},
		setContactinfo(state, contactinfo) {
			state.contactinfo = contactinfo
			localStorage.setItem('contactinfo', JSON.stringify(contactinfo))
		},
		setCruiseinfo(state, cruiseinfo) {
			state.cruiseinfo = cruiseinfo
			localStorage.setItem('cruiseinfo', JSON.stringify(cruiseinfo))
		}
	}
}